import classNames from 'classnames';
import { useState } from 'react';
import Button from '../../../../Button';
import Image from '../../../../Image';
import MediaGallery from './../../../../MediaGallery';

export default function MessageMedia({ message, side, user }) {
  const [isOpen, setIsOpen] = useState(false);

  if (!message.id) {
    return null;
  }

  const { images } = message.media;
  if (!images.length) {
    return null;
  }

  const wrapperClasses = classNames('media', {
    'grid-cols-2 gap-1': images.length > 1,
    'md:!h-28': side,
  });

  const handleClick = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <section className={wrapperClasses}>
        {images.map(({ src }, i) => {
          return (
            <Button
              onClick={handleClick}
              key={src}
              variant="clear"
              className="relative bg-gray-300"
            >
              <Image
                src={src}
                className="w-full h-full object-contain"
                alt={`${user.name} message media ${i + 1}${
                  message.message ? ` ${message.message}` : ''
                }`}
              />
            </Button>
          );
        })}
      </section>
      {isOpen && <MediaGallery onClose={handleClose} message={message} user={user} />}
    </>
  );
}
